import { CreateAnimation, createAnimation, IonCol, IonGrid, IonRow } from '@ionic/react';
import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import {StyledActionIonModal, StyledActionSheet, StyledIonModal} from '../../../../components/modal/modal.style';
import { StyledWalletGrid } from '../../panes/wallet.style';
import {EmployerAddon, EmployerWallet, MonthWallet, WorkingHour} from '../../panes/walletPane.component';
import CloseImage from '../../../../assets/images/e-remove.svg';
import { StyledWalletAddonsActionSheetContainer } from './walletAddonsActionSheet.style';
import { StyledPaneBar, StylePaneGrabber } from '../../../../components/pane/pane.style';
import { useSwipeable } from 'react-swipeable';
import ModalService from '../../../../services/modal.service';

type WalletAddonsActionSheetProps = {
    isVisible: boolean;
    wallet?: MonthWallet;
    onDismiss: () => void;
}

const WalletAddonsActionSheet: React.FC<WalletAddonsActionSheetProps> = (props: WalletAddonsActionSheetProps) => {

    const [isVisible, changeVisibility] = useState(false);
    const [hiding, startHiding] = useState(false);
    const [showDetails, updateShowDetails] = useState(false);
    const {t} = useTranslation();

    useEffect(() => {
        if (isVisible !== props.isVisible) {
            if (props.isVisible) {
                ModalService.modalOpened(props.onDismiss);
                startHiding(false);
                changeVisibility(props.isVisible);
            } else {
                ModalService.modalDismissed();
                startHiding(true);
                setTimeout(() => changeVisibility(props.isVisible), 275);
            }
        }
    }, [isVisible, props.isVisible]);

    const config = {
        delta: 10,                            // min distance(px) before a swipe starts
        preventDefaultTouchmoveEvent: false,  // call e.preventDefault *See Details*
        trackTouch: true,                     // track touch input
        trackMouse: false,                    // track mouse input
        rotationAngle: 0,                     // set a rotation angle
      };

    const handlers = useSwipeable({
        onSwipedDown: (eventData) => {
            props.onDismiss();
        },
        ...config,
    });

    const getMonthAddonsTotal = (monthWallet: MonthWallet): number => {
        const sum = monthWallet.addons.reduce((prev: number, curr: EmployerAddon) => {
            return prev + (curr.value * 1);
        }, 0);

        return sum;
    };

    return isVisible ? (
        <StyledIonModal
            isOpen={props.isVisible}
            onDidDismiss={() => props.onDismiss()}
            initialBreakpoint={0.99}
            breakpoints={[0, 0.65, 0.99]}
        >
                <StyledWalletAddonsActionSheetContainer className={hiding ? 'hide': 't-p-50'} onClick={(e) => e.stopPropagation()}>
                    <img src={CloseImage} className="close" onClick={(e) =>{ props.onDismiss(); e.stopPropagation()} } />
                    <StyledWalletGrid>
                        <div className="title">{t("reportsTab.wallet.detailsView")}</div>
                        <IonGrid>
                            <IonRow>
                                <IonCol className="aligment header" size="8.5">
                                {t("reportsTab.wallet.workingPlace")}
                                </IonCol>
                                <IonCol className="aligment end header" size="3.5">
                                {t("reportsTab.wallet.amount")}
                                </IonCol>
                            </IonRow>
                        </IonGrid>

                        <IonGrid className="content">
                            { props.wallet && props.wallet.addons && props.wallet.addons.length > 0 &&
                                props.wallet.addons.map((addon, key) =>
                                <IonRow key={key}>
                                    <IonCol className="aligment row" size="8.5">
                                        {addon.name}
                                    </IonCol>
                                    <IonCol className="aligment end row value" size="3.5">
                                        {addon.value}
                                    </IonCol>
                                </IonRow>
                                )
                            }

							{ props.wallet && props.wallet.addons.length == 0 &&
								<IonRow>
									<IonCol className="aligment row" size="12">
										{t("reportsTab.wallet.noAddons")}
									</IonCol>
								</IonRow>
							}

						</IonGrid>

						<IonGrid>

							{ props.wallet && props.wallet.addons.length > 0 &&
								<IonRow className="footer">
									<IonCol className="aligment footer" size="5.5">
									{t("reportsTab.wallet.addonsSum")}
									</IonCol>
									<IonCol className="aligment end footer" size="3">

									</IonCol>
									<IonCol className="aligment end footer" size="3.5">
                                        {(Math.floor(getMonthAddonsTotal(props.wallet) * 100)/100).toFixed(2)}
									</IonCol>
								</IonRow>
							}
						</IonGrid>
                    </StyledWalletGrid>
                </StyledWalletAddonsActionSheetContainer>
        </StyledIonModal>
    ) : (<span></span>);
};

export default WalletAddonsActionSheet;
